// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/transfers/sdd_collections_orchestrator/mandates/firstparty/v1/get_invitation_link.proto

/* eslint-disable */

/** Request for getting the organization's invitation link. */
export interface ApiGetInvitationLinkRequest {
}

/** Response containing the invitation link details. */
export interface ApiGetInvitationLinkResponse {
  /** Unique identifier for the invitation link. */
  readonly invitationLinkId: string;
  /**
   * URL of the invitation link.
   * Used by Mobile, not Web
   * Production format: "https://pay.qonto.com/mandate-invite/{invitation_link_id}"
   * Staging format: "https://receivable-invoices-js-${NAMESPACE}.staging${EKS_CLUSTER_ID}.qonto.co/mandate-invite/{invitation_link_id}"
   */
  readonly invitationLinkUrl: string;
}

export const ApiGetInvitationLinkRequest: MessageFns<ApiGetInvitationLinkRequest> = {
  fromJSON(_: any): ApiGetInvitationLinkRequest {
    return {};
  },

  toJSON(_: ApiGetInvitationLinkRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiGetInvitationLinkResponse: MessageFns<ApiGetInvitationLinkResponse> = {
  fromJSON(object: any): ApiGetInvitationLinkResponse {
    return {
      invitationLinkId: isSet(object.invitationLinkId) ? globalThis.String(object.invitationLinkId) : "",
      invitationLinkUrl: isSet(object.invitationLinkUrl) ? globalThis.String(object.invitationLinkUrl) : "",
    };
  },

  toJSON(message: ApiGetInvitationLinkResponse): unknown {
    const obj: any = {};
    if (message.invitationLinkId !== "") {
      obj.invitationLinkId = message.invitationLinkId;
    }
    if (message.invitationLinkUrl !== "") {
      obj.invitationLinkUrl = message.invitationLinkUrl;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
